import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const labResultsApi = baseApi.injectEndpoints({
  tagTypes: ['LabResultsList'],
  endpoints: (builder) => ({
    getLabResultsList: builder.query({
      query: (params) => {
        return {
          url: `/labs/search_orders.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {return parseResponse(response);},
    }),
    getLabResultsPrintData: builder.query({
      query: (params) => {
        return {
          url: `/labs/print_result.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {return parseResponse(response);},
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetLabResultsListQuery } = labResultsApi;
